import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function CrearZona({ onClose = () => {}, onCreated = () => {} }) {
  const [nombre, setNombre] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = nombre.trim() !== "";

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);
    setError("");
    try {
      const payload = { nombre: nombre.trim() };
      const created = await appFetchJson(apiRoutes.zonas.create, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      onCreated(created);
      onClose();
    } catch (e) {
      console.error("Error creando zona:", e);
      setError(e?.message || "Ocurrió un error al guardar la zona.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Zona</h2>
          <button className="modal-close-x" onClick={onClose}><FaTimes /></button>
        </div>
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">Introduzca el nombre de la nueva zona</p>
          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}
          <div className="form-grid">
            <div className="form-row">
              <label className="form-label">Nombre *</label>
              <input
                type="text"
                className="input"
                value={nombre}
                onChange={e => setNombre(e.target.value)}
                placeholder="Nombre de la zona"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar label="Guardar" isValid={isValid} saving={saving} onClick={guardar} />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}